export enum EngineExceptionEnum {
  PRODUCT = "PRODUCT",
  NCM = "NCM",
}

export enum ExceptionTypeEnum {
  ICMS = "ICMS",
  PIS = "PIS",
  COFINS = "COFINS",
  FCP = "FCP",
  ICMS_DESONERADO = "ICMS_DESONERADO",
  IBS = "IBS",
  CBS = "CBS",
}

export enum ReasonEnum {
  TAXI = 1,
  PRODUTOR_AGROPECUARIO = 3,
  FROTISTA_LOCADORA = 4,
  DIPLOMATICO_CONSULAR = 5,
  AMAZONIA_OCIDENTAL = 6,
  SUFRAMA = 7,
  VENDA_ORGAO_PUBLICO = 8,
  OUTROS = 9,
  DEFICIENTE_CONDUTOR = 10,
  DEFICIENTE_NAO_CONDUTOR = 11,
  SOLICITADO_FISCO = 90,
}
